// extracted by mini-css-extract-plugin
export default {"root":"CategoriesAccordion_root__S7EdF","notActiveHeader":"CategoriesAccordion_notActiveHeader__WT-eW","placeHolderShimmer":"CategoriesAccordion_placeHolderShimmer__BN1f6"};